(function() {
    const formElement = document.querySelector('[data-product-form]');
    const idInput = document.querySelector('input[name=id]');
    const productHandle = formElement.dataset.productHandle;
    const addToCartButton = document.getElementById('add-to-cart-button');
    const defaultButtonText = addToCartButton.getAttribute('data-default-text');
    const unavailableButtonText = addToCartButton.getAttribute('data-unavailable-text');
    const productPrice = document.getElementById('single-product-price');
    
    fetch(`/products/${productHandle}.js`).then(response => {
        return response.json();
    }).then(productJSON => {
        const productForm = new Shopify.theme.productForm.ProductForm(formElement, productJSON, {
            onOptionChange
        });
    }); 
    
    // This function is called whenever the user changes the value of an option input
    function onOptionChange(event) {
        const variant = event.dataset.variant;

        if (variant && variant.featured_image && variant.featured_image.id) {
            const $sliderImage = jQuery('#single-product-gallery img[data-id="' + variant.featured_image.id + '"]');
            if ($sliderImage.length) {
                const $slide = $sliderImage.closest('.slick-slide');
                const dataIndex = $slide.data('slick-index');
                jQuery('#single-product-gallery').slick('slickGoTo', dataIndex, true);
            } else {
                console.log('no image found for variant image id', variant.featured_image.id);
            }
        }

        if (variant === null) {
            return;
        } else if (variant && !variant.available) {
            addToCartButton.disabled = true;
            addToCartButton.innerText = unavailableButtonText;
        } else if (variant && variant.available) {
            addToCartButton.disabled = false;
            addToCartButton.innerText = defaultButtonText;
        }
        productPrice.innerText = Shopify.formatMoney(variant.price);
        idInput.value = variant.id;
    }      
})();